import moment from 'moment';
import type { TFunction } from 'i18next';
import type React from 'react';
import { type FormControlWrapperOption, type FormControlWrapperType } from './interfaces';

const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';

export interface FormatDisplayValueOptions {
    type?: FormControlWrapperType;
    options?: FormControlWrapperOption[];
    dateFormat?: string;
    t?: TFunction;
}

export function formatDisplayValue(rawValue: unknown, opts: FormatDisplayValueOptions = {}): React.ReactNode {
    const { type = 'text', options, dateFormat = DEFAULT_DATE_FORMAT, t = ((key: string) => key) as TFunction } = opts;

    const yesNoOtherOptions = [
        { value: 'Y', label: t('yes') },
        { value: 'N', label: t('no') },
        { value: 'O', label: t('other') },
        { value: true, label: t('yes') },
        { value: false, label: t('no') },
    ];

    if (rawValue === undefined || rawValue === null || rawValue === '') {
        return '';
    }

    switch (type) {
        case 'date': {
            const parsed = moment(rawValue as moment.MomentInput);
            return parsed.isValid() ? parsed.format(dateFormat) : '';
        }
        case 'select':
        case 'radio': {
            const match = options?.find((option) => String(option.value) === String(rawValue));
            return match ? match.label : '';
        }
        case 'multiselect': {
            const values = Array.isArray(rawValue) ? rawValue : [rawValue];
            return values
                .map((value) => options?.find((option) => String(option.value) === String(value))?.label)
                .filter((label): label is React.ReactNode => label !== undefined)
                .join(', ');
        }
        case 'radio.yesnoother': {
            const match = yesNoOtherOptions.find((option) => option.value === rawValue);
            return match ? match.label : '';
        }
        case 'radio.yesno':
        case 'checkbox':
            return rawValue ? t('yes') : t('no');
        case 'text':
        default:
            return String(rawValue);
    }
}
